export const ShipmentStatusSupplierPage = () => {
  return <>ShipmentStatusSupplierPage</>;
};
